import { Box, Stack } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { TimelineHeader } from '../../molecules/folder-label/TimelineHeader';
import { TimelineItemCard } from '../../molecules/folder-label/TimelineItemCard';
import type { TimelineEntry } from '../../../types/folder-label';

const useStyles = makeStyles(() => ({
    timelineLine: {
        marginLeft: '24px',
        borderLeft: '2px solid #e5e7eb',
        paddingLeft: '16px',
    },
}));

interface TimelineListProps {
    entries: TimelineEntry[];
}

export const TimelineList: React.FC<TimelineListProps> = ({ entries }) => {
    const classes = useStyles();

    return (
        <Box>
            {entries.map((entry, idx) => (
                <Box key={idx} mb={3}>
                    <TimelineHeader
                        date={entry.date}
                        relativeTime={entry.relativeTime}
                        count={entry.count}
                        type={entry.type}
                    />
                    <Box className={classes.timelineLine}>
                        <Stack spacing={1.5}>
                            {entry.items.map((item, itemIdx) => (
                                <TimelineItemCard
                                    key={itemIdx}
                                    item={item}
                                    type={entry.type}
                                />
                            ))}
                        </Stack>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};
